import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Users/";

const validate = async (lat, lon) => await axiosInstance.post(ENDPOINTORIGIN + 'Validate?lat=' + lat + '&lon=' + lon, {}, constants.REQUIRE_INTERCEPTORS);

const getAllUsers = async (isProjectManagerView, isActive = true) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAllUsers?isProjectManagerView=' + isProjectManagerView + '&isActive=' + isActive, constants.REQUIRE_INTERCEPTORS)

const registerUser = async (user) => await axiosInstance.post(ENDPOINTORIGIN + 'Register', user, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true })

const getUserProfile = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserProfile?id=' + id, constants.REQUIRE_INTERCEPTORS);

const updateUserAvatar = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateUserPicture', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true })

const updatePersonalInformation = async (user) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdatePersonalInformation', user, constants.REQUIRE_INTERCEPTORS)

const updateCompanyInformation = async (user) => await axiosInstance.post(ENDPOINTORIGIN + 'UpdateCompanyInformation', user, constants.REQUIRE_INTERCEPTORS)

const changeUserPassword = async (userId, pwd) => await axiosInstance.post(ENDPOINTORIGIN + `ChangeUserPassword?userId=${userId}&password=${pwd}`, {}, constants.REQUIRE_INTERCEPTORS)

const getProfileCardInfo = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProfileCardInfo?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getPersonalInfo = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetPersonalInfo?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getUserCompanyInfo = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserCompanyInfo?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getUserSSN = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserSSN?id=' + id, constants.REQUIRE_INTERCEPTORS);

const updateUserSSN = async (id, ssn) => await axiosInstance.post(ENDPOINTORIGIN + `UpdateUserSSN?id=${id}&ssn=${ssn}`, {}, constants.REQUIRE_INTERCEPTORS);

const getUserSessions = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserSessions?userId=' + id, constants.REQUIRE_INTERCEPTORS);

const getMyTimeSheet = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'GetMyTimeSheet', model, constants.REQUIRE_INTERCEPTORS);

export {
    getAllUsers,
    registerUser,
    getUserProfile,
    updateUserAvatar,
    updatePersonalInformation,
    updateCompanyInformation,
    changeUserPassword,
    getProfileCardInfo,
    getPersonalInfo,
    getUserCompanyInfo,
    getUserSSN,
    updateUserSSN,
    validate,
    getUserSessions,
    getMyTimeSheet
}